import React, { Component } from 'react';
import '../../assets/styles/Converter/ErrorMessage.sass';

class ErrorMessage extends Component {
  render() {
    return <p className={`ErrorMessage ${this.props.hasError ? 'show' : ''}`}>This field can't be blank.</p>;
  }
}

export default ErrorMessage;
